import { render, staticRenderFns } from "./footerBlogroll.vue?vue&type=template&id=40e6b4b3&scoped=true&"
import script from "./footerBlogroll.vue?vue&type=script&lang=js&"
export * from "./footerBlogroll.vue?vue&type=script&lang=js&"
import style0 from "./footerBlogroll.vue?vue&type=style&index=0&id=40e6b4b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e6b4b3",
  null
  
)

export default component.exports